import { useState } from "react";
import { useUIFlags } from "../../../misc/UIFlags";

const shownKey = "swipe-nudge-shown";
const sessionsKey = "swipe-nudge-sessions";

// maxSessions is how many visits the hint shows on before it stops for good, for a
// user who never swipes
const maxSessions = 3;

// useSwipeNudge is whether the row hint that a task can be swiped should play now. It
// plays once per visit rather than on every day the user steps to, and gives up after
// a few visits, until the user swipes for the first time (see DayTaskRow).
export function useSwipeNudge(enabled: boolean) {
    const flags = useUIFlags();

    const [show] = useState(() => {
        if (!enabled || flags.has("swipe")) return false;
        if (sessionStorage.getItem(shownKey)) return false;

        const sessions = Number(localStorage.getItem(sessionsKey) || 0);
        if (sessions >= maxSessions) return false;

        sessionStorage.setItem(shownKey, "true");
        localStorage.setItem(sessionsKey, String(sessions + 1));
        return true;
    });

    return show && !flags.has("swipe");
}
